<template>
    <div class="cents">
        <van-nav-bar
        :title="$t('yckm')"
        left-arrow
        safe-area-inset-top
        style="background-color: #1ABC9C;"
        @click-left="goto"
        />
        <div class="requist">
            <van-field
            :border="true"
            clearable
            size='large'
            v-model="keyword"
            :placeholder="$t('sbmhzwz')"
            />
            <van-button color="#1ABC9C" size="small" @click="questlist">{{$t('cxwz')}}</van-button>
        </div>
        <!-- <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('mygd')"
            @load="onLoad"
        > -->
            <div class="equtcont">
                <!-- <h4>风华一区</h4> -->
                <div class="" v-for="item in equdatalist" :key="item.id">
                    <div class="costplas " >
                        <div :class="item.is_online? 'yuan colorsold ': 'yuan colors' ">
                            <van-icon name="wap-home" />
                        </div>
                        <div style="flex:3;text-align: center;line-height:28px">
                            <p style="margin:0">{{sbwz}}：{{item.name}}</p>
                            <span>{{zt}}：{{item.is_online? $t('zx') :$t('lx')}}</span>
                        </div>

                        <div style="flex:1;text-align: right;line-height: 40px;">
                            <van-button @click="Opendoor(item)" color="#1ABC9C" :disabled="item.is_online?false :true"  type="primary" size="small">{{$t('kmen')}}</van-button>
                        </div>

                    </div>
                </div>
            </div>
        <!-- </van-list> -->
        <!-- <div style="padding-bottom:80px"> -->
			<!-- 分页 -->
			<div class="data-load-more" v-if="deviceCount>10||Math.ceil(deviceCount/10)>1">
				<div @click="goTop">{{this.$t('syy')}}</div>
				<div style="width: 25px;" @click="pageTop" v-if="pageSizeList[0]!=1">...</div>
				<div class="pageSizeBox">
					<div v-for="(item,index) in pageSizeList" :key="item" style="width: 25px;" @click="handlePageSize(item)" :class="[page_index==item?'pageSizeItemState':'']">
						{{item>pageSize?'':item}}
					</div>
				</div>
				<div style="width: 25px;" @click="pageBottom" v-if="pageSize>pageSizeList[4]">...</div>
				<div @click="goBottom">{{this.$t('xyy')}}</div>
			</div>
        <!-- </div> -->

    </div>
</template>
<script>
import { Toast } from 'vant';
import axios from 'axios'
import qs from 'qs'
export default {
    data(){
        return{
            loading:false,
            finished: false,
            keyword:'',
            Userof:JSON.parse(window.localStorage.getItem('getTokendata')),
            equdatalist:[],
            page_index:1,
            count:null,
            sbwz:this.$t('sbwz'),
            zt:this.$t('zt'),
			deviceCount:0, // 接口返回设备数量
			pageSize:0, // 设备页数
			pageSizeList:[1,2,3,4,5], // 页码
        }
    },
    mounted(){
        this.getequipment()
    },
    methods:{
        // 返回
        goto(){
            this.$router.go(-1)
        },
        //查询
        questlist(){
            this.getequipment()
        },
        // 开门
        Opendoor(item){
            console.log(item)

            let data={
                method : 'mqtt.door.open',
                userId:this.Userof.user_id,
                serial:item.serial,
                password:item.password
            }
            data = qs.stringify(data)
            axios.post('https://web.fondcard.net/open/mqtt/api.php?method=mqtt.door.open',data).then(res=>{
                if(res.data.code==0){
                    Toast.success(this.$t('kmcg'));
                }else{
                    Toast.fail(this.$t('kmsb'));
                }
            })  
        },
		// 页码点击
		handlePageSize(index){
			console.log(index,this.pageSize);
			console.log(this.page_index);
			 if(index>this.pageSize){
				return
			};
			this.page_index = index;
			this.getequipment()
		},
		// 上个页码
		pageTop(){
			let pageArr = []
			this.pageSizeList.forEach(item=>{
			  item-=5
			  pageArr.push(item)
			})
			this.pageSizeList = pageArr;
		},
		// 下页码
		pageBottom(){
			let pageArr = []
			this.pageSizeList.forEach(item=>{
			  item+=5
			  pageArr.push(item)
			})
			this.pageSizeList = pageArr
		},
		// 上一页
		goTop(){
			if(this.deviceCount==0){
			  return
			};
			if(this.page_index==1){
			  this.$message.info(this.$t('ysdyy'))
			  return
			};
			this.page_index--;
			if(this.page_index<this.pageSizeList[0]){
				let pageArr = []
				this.pageSizeList.forEach(item=>{
				item-=5
				pageArr.push(item)
				})
				this.pageSizeList=pageArr,
				this.page_index=pageArr[4]
			}
			this.getequipment()
		},
		// 下一页
		goBottom(){
			if(this.deviceCount==0){
			  return
			}
			if(this.page_index==this.pageSize){
			  this.$message.info(this.$t('mygd'))
			  return
			}
			this.page_index++;
			if(this.page_index>this.pageSizeList[4]){
				let pageArr = []
				this.pageSizeList.forEach(item=>{
				item+=5
				pageArr.push(item)
				})
				this.pageSizeList=pageArr,
				this.page_index=pageArr[0]
			}
			this.getequipment()
		},
        // 设备列表
        onLoad() {
            this.page_index++;
            this.getequipment()
        },
        getequipment(){
            let data={
                method:'co.wx.remote.device.list',
                user_id:this.Userof.user_id,
                page_index:this.page_index,
                page_size:10,
                keyword:this.keyword
            }
            this.$serve(data).then(res=>{
                if(res.data.code==0){
                    this.equdatalist = res.data.data
					this.deviceCount = res.data.count;
					this.pageSize = Math.ceil(res.data.count/10);
                    this.loading = false;
                    this.count = res.data.count
                    if (res.data.data == [] || this.count.length === 0) {
                        // 加载结束
                        this.finished = true;
                        return;
                    }
                    // this.equdatalist = this.equdatalist.concat(res.data.data)
                    
                    if (this.equdatalist.length >= this.count) {
                        this.finished = true;
                    }
                }
                
            })
        },
    }
}
</script>
<style scoped>
	.data-load-more{
		width: 100%;
		height: 50px;
		line-height: 50px;
		background-color: #eee;
		text-align: center;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
		margin-top: 20px;
	}
	.pageSizeBox{
		width: 50%;
		display: flex;
		justify-content: space-around;
	}
	.pageSizeItem{
	  width: 50rpx;
	}
	.pageSizeItemState{
	  color: #ff2146;
	  text-decoration: underline;
	}
.requist{
    width: 92%;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-around;
}
.requist >>> .van-cell{
    width: 250px;
    border: 1px solid #ccc;
    padding: 4px 6px;
    border-radius:4px ;
}

.equtcont{
    margin: 0 auto;
    width: 90%;
    /* border-left: 5px solid #C280FF; */
}
.equtcont h4 {
    text-align: left;
    margin-left:10px ;
}

.costplas{
    /* margin-left: 10px; */
    display: flex;
    justify-content: space-around;
    font-size: 14px;
    margin-top: 15px;
}
.yuan{
    /* margin: 0 auto; */
    width: 60px;
    height: 60px;
    border-radius:50% ;
    line-height: 70px;
    text-align: center;
    font-size: 38px;
    
}
.colors{
    color: #ccc;
    border: 1px solid #ccc;
}
.colorsold{
    color: #1ABC9C;
    border: 1px solid #1ABC9C;
}
.cents >>>.van-nav-bar__title{
    color: #fff;
}
.cents>>>.van-nav-bar .van-icon{
    color: #fff;
}
</style>